// joinPins mirrors the apps' shared joinPins (spec 010 FR-004, specs/010-app/research.md): members whose pins would overlap on screen show as one pin at the
// mean of their locations.

/** PinSpot is a member's location and where it falls on screen, in pixels. */
export interface PinSpot {
  id: string;
  lat: number;
  lon: number;
  x: number;
  y: number;
}

/** PinJoin is one pin on the map: its members, in order, and where its tip goes. */
export interface PinJoin {
  ids: string[];
  lat: number;
  lon: number;
}

/**
 * joinPins takes spots in the order given, which callers keep fixed, and
 * joins each to the first pin whose first member's spot is within apart, so
 * the same spots always give the same pins. The member alone, the one
 * selected, keeps a pin of their own.
 */
export function joinPins(spots: PinSpot[], apart: number, alone: string | null = null): PinJoin[] {
  const seeds: PinSpot[] = [];
  const members: PinSpot[][] = [];
  for (const s of spots) {
    const i = s.id === alone ? -1 : seeds.findIndex(
      (k) => k.id !== alone && Math.hypot(k.x - s.x, k.y - s.y) < apart,
    );
    if (i >= 0) {
      members[i].push(s);
    } else {
      seeds.push(s);
      members.push([s]);
    }
  }
  return members.map((m) => ({
    ids: m.map((s) => s.id),
    lat: m.reduce((a, s) => a + s.lat, 0) / m.length,
    lon: m.reduce((a, s) => a + s.lon, 0) / m.length,
  }));
}
